import { ComponentProps } from "."
import { PillBase, PillContent, PillIconSlot } from "./styled"

const Pill = ({
  ariaLabel,
  className,
  icon,
  label,
  onClick,
  size = "md",
  tone = "default"
}: ComponentProps) => {
  const fallbackAriaLabel = onClick ? label : `Status pill: ${label}`
  const accessibleLabel = ariaLabel ?? fallbackAriaLabel

  const content = (
    <PillContent>
      {icon ? <PillIconSlot>{icon}</PillIconSlot> : null}

      <span>{label}</span>
    </PillContent>
  )

  return (
    <PillBase
      $clickable={Boolean(onClick)}
      $size={size}
      $tone={tone}
      aria-label={accessibleLabel}
      as={onClick ? "button" : "span"}
      className={className}
      onClick={onClick}
      tabIndex={onClick ? undefined : -1}
      type={onClick ? "button" : undefined}
    >
      {content}
    </PillBase>
  )
}

export default Pill
